import { Inject, Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { distinctUntilChanged, filter, map } from 'rxjs';
import * as fromConfig from '../config';
import { getDebugFlagSettings } from '../selectors/debug-flag.selectors';
import { uniq, flattenDeep } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class DebugFlagsService {
    constructor(store, debugFlagList) {
        this.store = store;
        this.debugFlagList = debugFlagList;
        this.debugFlagSettings$ = this.store.pipe(select(getDebugFlagSettings));
        this.debugFlagSettings$.pipe(distinctUntilChanged()).subscribe(settings => {
            if (settings != null) {
                this.debugFlagSettings = settings;
                this.flags
                    .filter(flag => !!flag.onChange)
                    .forEach(flag => {
                    flag.onChange(!!this.debugFlagSettings[flag.name], this.debugFlagSettings[flag.name]);
                });
            }
        });
    }
    get flags() {
        return uniq(flattenDeep(this.debugFlagList || []));
    }
    get settings() {
        return this.debugFlagSettings;
    }
    hasDebugFlag(flagName) {
        return this.debugFlagSettings && !!this.debugFlagSettings[flagName];
    }
    getDebugFlagMetadata(flagName) {
        return this.debugFlagSettings[flagName];
    }
    hasDebugFlagAsync(flagName) {
        return this.debugFlagSettings$.pipe(filter(settings => !!settings), map(settings => !!settings[flagName]));
    }
    getDebugFlagMetadataAsync(flagName) {
        return this.debugFlagSettings$.pipe(filter(settings => !!settings), map(settings => settings[flagName]));
    }
    static { this.ɵfac = function DebugFlagsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DebugFlagsService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(fromConfig.DebugFlagList)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DebugFlagsService, factory: DebugFlagsService.ɵfac }); }
}
//# sourceMappingURL=debug-flags.service.js.map